// extracted by mini-css-extract-plugin
module.exports = {"userPhone":"SalonContact_userPhone__B9g_I","userEmail":"SalonContact_userEmail__ZasG_"};